import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Menu, MenuItem, IconButton, ListItemIcon, ListItemText,
} from '@mui/material';
// component
import { usePrivilege } from '../../../PrivilegeContext';
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

export default function PassMoreMenu({
  handleSeeMore, handleEditOpen, handleAssignOpen, data, canAssign,
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const { role } = usePrivilege();

  return (
    <>
      <IconButton
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          sx={{ color: 'text.secondary' }}
          onClick={() => {
            handleSeeMore(data);
          }}
        >
          <ListItemIcon>
            <Iconify icon="heroicons:signal-solid" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="See More" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        {(role === 900 || role === 101 || role === 111 || role === 102) && (
          <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }} onClick={() => handleEditOpen(data)}>
            <ListItemIcon>
              <Iconify icon="eva:edit-fill" width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {canAssign && (
          <MenuItem sx={{ color: 'text.secondary' }} onClick={() => handleAssignOpen(data)}>
            <ListItemIcon>
              <Iconify icon="eva:person-add-fill" width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Assign" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
